import React, { useState } from "react";
import { Outlet } from "react-router-dom";

import Header from "../components/header";

import { ContentWrapper, ScreenLayout } from "./style";
import EmployeePortalNav from "../components/menu/employee-portal-nav";
function EmployeePortalLayout() {
  React.useEffect(() => {
    const dynamicElement = document.getElementById("header");
    const handleScroll = () => {
      if (window.scrollY > 0) {
        dynamicElement.classList.add("sticky");
      } else {
        dynamicElement.classList.remove("sticky");
      }
    };
    window.addEventListener("scroll", handleScroll);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [isNavActive, setIsNavActive] = useState(false);
  // Toggle the nav state
  const toggleNav = () => {
    setIsNavActive(!isNavActive);
  };
  return (
    <>
   
      <ScreenLayout>
        <Header isNavActive={isNavActive} toggleNav={toggleNav} />
        <EmployeePortalNav isNavActive={isNavActive} />
        <ContentWrapper className={isNavActive ? "navCollapse" : ""}>
          <Outlet />
        </ContentWrapper>
      </ScreenLayout>
    
    </>
  );
}

export default EmployeePortalLayout;
